import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'In welchem Format erhalte ich die Materialien?',
  a: 'Sie erhalten 11 hochauflösende PDF-Dateien, übersichtlich in Ordnern organisiert. Kompatibel mit jedem Gerät und Drucker.'
}, {
  q: 'Ist es eine einmalige Zahlung?',
  a: 'Ja. Sie zahlen einmalig und erhalten lebenslangen Zugang zu allen Materialien, inklusive aller zukünftigen Updates. Kein Abonnement.'
}, {
  q: 'Für welche Schulstufe ist das System geeignet?',
  a: 'Das System wurde speziell für die Sekundarstufe II, das Gymnasium und die Berufsmaturität entwickelt. 100% konform mit dem aktuellen Lehrplan 21.'
}, {
  q: 'Kann ich die PDFs bearbeiten?',
  a: 'Die Module sind im PDF-Format gesichert, um das Drucklayout zu schützen. Die Arbeitsblätter enthalten jedoch ausfüllbare Felder, die Ihre Schüler direkt am Bildschirm oder ausgedruckt verwenden können.'
}, {
  q: 'Was passiert nach dem Kauf?',
  a: 'Sofort nach dem Kauf erhalten Sie eine E-Mail mit dem Download-Link zu Ihrem persönlichen Ordner mit allen PDFs. Kein Warten. Kein Versand. Sofort unterrichten.'
}, {
  q: 'Ist das Material aktuell für 2026 (OR/ZGB)?',
  a: 'Ja, alle Module, insbesondere Tomo 1 (Rechtssicherheit & Verträge), basieren auf der aktuellsten Schweizer Rechtsprechung und Gesetzgebung für das Jahr 2026.'
}, {
  q: 'Was ist der Unterschied zwischen Basis- und Experten-System?',
  a: 'Das Experten-System enthält zusätzlich 100 detaillierte Schweizer Fallstudien (80 Seiten) zu Unternehmensrecht, Arbeitsstreitigkeiten, Makroökonomie und KMU-Strategie, jeweils mit Sachverhalt, Fragen und Musterlösung.'
}, {
  q: 'Kann ich das Material auch für die Berufsmaturität nutzen?',
  a: 'Absolut. Die inhaltliche Tiefe und der starke Praxisbezug (z.B. reale SECO-Daten, KMU-Fokus) machen es ideal für den W&R-Unterricht an der Berufsmaturität.'
}, {
  q: 'Wie funktioniert die 7-Tage-Garantie konkret?',
  a: 'Schreiben Sie uns einfach innerhalb von 7 Tagen nach dem Kauf eine kurze E-Mail. Wir erstatten den vollen Kaufpreis umgehend zurück, ohne Rückfragen.'
}, {
  q: 'Eignet sich das System auch für bilinguale Klassen?',
  a: 'Ja, das System beinhaltet als Bonus ein bilinguales Glossar (DE/EN) mit 200 Fachbegriffen, was es zu einer hervorragenden Unterstützung für den bilingualen Unterricht macht.'
}];
export function FAQ() {
  const [openIndex, setIndex] = useState<number | null>(null);
  return <section className="py-12 px-4 bg-swiss-card-bg border-y border-gray-200" data-id="element-41">
      <div className="max-w-2xl mx-auto" data-id="element-42">
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-8 text-swiss-charcoal" data-id="element-43">
          Häufig gestellte Fragen
        </h2>

        <div className="space-y-3" data-id="element-44">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-45">
              <button onClick={() => setIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors" data-id="element-46">
                <span className="font-bold text-swiss-charcoal text-sm sm:text-base pr-4" data-id="element-47">
                  ❓ {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-gray-400 transition-transform duration-200 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-48" />
              </button>

              <AnimatePresence data-id="element-49">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-50">
                    <div className="px-5 pb-4 pt-0 text-gray-600 text-sm sm:text-base leading-relaxed" data-id="element-51">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}